/** Shared call-log display helpers (no React). */

export const formatCallDuration = (row: any): string => {
  if (row?.durationFormatted) return String(row.durationFormatted);
  const sec = Number(row?.callDurationSeconds);
  if (!Number.isFinite(sec) || sec < 0) return "";
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  return h
    ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    : `${m}:${String(s).padStart(2, "0")}`;
};

export const statusBadgeClass = (statusRaw: string) => {
  const status = String(statusRaw || "").toUpperCase();
  if (/MISS|FAIL|BUSY|NO_ANSWER|CANCEL|REJECT/.test(status)) {
    return "bg-red-50 text-red-600";
  }
  if (
    /RING|DIAL|INITIAT|CONNECT/.test(status) &&
    !/COMPLETED|ENDED|ANSWER/.test(status)
  ) {
    return "bg-amber-50 text-amber-700";
  }
  if (/ANSWER|RECEIV|COMPLETE|ENDED/.test(status)) {
    return "bg-emerald-50 text-emerald-700";
  }
  return "bg-slate-50 text-slate-600";
};
